import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const modeloFormularioImporterSelectors = importerSelectors(
  'modeloFormulario.importer',
);

export default modeloFormularioImporterSelectors;
